<template>
  <div class="psPatientEventsHistory">
    <div style="display: flex; justify-content: flex-start; margin-bottom: 10px;">
      <el-button type="primary" @click="createNewEvent" round size="small">Crear nuevo evento</el-button>
    </div>

    <div class="titles">
      <div class="date">Fecha</div>
      <div class="type">Tipo</div>
      <div class="description">Observaciones</div>
      <div class="description">Acción tomada</div>
    </div>

    <div class="contentItems" v-loading="loading">
      <div
        class="eventItem"
        v-for="(event, index) in sortedEvents"
        :key="event.calendarId || index"
        @click="openEvent(event)"
      >
        <div class="date">{{ formatDate(event.calendarDate) }}</div>
        <div class="type">{{ event.calendarTypeDescription }}</div>
        <div class="description">{{ event.calendarDescription }}</div>
        <div class="description">{{ event.action }}</div>
      </div>
      <div class="empty" v-if="!loading && sortedEvents.length == 0">
        No hay eventos para este paciente
      </div>
    </div>

    <ps-event-dialog
      :visible.sync="eventDialogVisible"
      title="Editar evento"
      :patient="dialogPatient"
      :event="selectedEvent"
      @save="saveAllEvents"
      @delete="deleteEvent"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import PsEventDialog from '@/shared/components/PsEventDialog.vue'
import calendarEventsMixin from '@/shared/mixins/calendarEventsMixin'

export default {
  name: 'PsPatientEventsHistory',
  components: { PsEventDialog },
  mixins: [calendarEventsMixin],
  data () {
    return {
      loading: false,
      eventDialogVisible: false,
      selectedEvent: null,
      targetPatients: []
    }
  },
  computed: {
    ...mapState('patients', ['patient']),
    ...mapState('calendar', ['patientCalendar', 'calendarItem']),
    sortedEvents () {
      return [...(this.patientCalendar || [])].sort(
        (a, b) => new Date(b.calendarDate) - new Date(a.calendarDate)
      )
    },
    dialogPatient () {
      return {
        patientId: this.patient.patientId,
        value: `${this.patient.name || ''} ${this.patient.surname || ''}`.trim()
      }
    }
  },
  methods: {
    ...mapMutations('calendar', ['CALENDAR_CALENDAR_ITEM']),
    ...mapActions('calendar', ['getPatientCalendarHTTP', 'deleteCalendarEventHTTP']),
    formatDate (value) {
      if (!value) return ''
      const date = String(value).substring(0, 10).split('-')
      return date.length == 3 ? `${date[2]}/${date[1]}/${date[0]}` : value
    },
    openEvent (event) {
      this.CALENDAR_CALENDAR_ITEM(Object.assign({}, event))
      this.selectedEvent = event
      this.eventDialogVisible = true
    },
    createNewEvent () {
      this.CALENDAR_CALENDAR_ITEM({})
      this.selectedEvent = null
      this.eventDialogVisible = true
    },
    async loadEvents () {
      if (!this.patient.patientId || this.patient.patientId == 0) return
      this.loading = true
      try {
        await this.getPatientCalendarHTTP(this.patient.patientId)
      } finally {
        this.loading = false
      }
    },
    async saveAllEvents (events) {
      for (const event of events) {
        await this.saveEvents(event)
      }
      this.eventDialogVisible = false
      await this.loadEvents()
    },
    deleteEvent () {
      this.$confirm('¿Confirma eliminar este evento?', 'Advertencia', {
        type: 'warning',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      })
      .then(async () => {
        await this.deleteCalendarEventHTTP()
        this.$message.success('Evento eliminado!')
        await this.loadEvents()
      })
      .catch(() => null)
      .finally(() => { this.eventDialogVisible = false })
    }
  },
  created () {
    this.loadEvents()
  }
}
</script>

<style scoped>
  .psPatientEventsHistory { margin-top: 10px; margin-bottom: 10px; }
  .titles { display: flex; color: #828282; text-align: left; border-bottom: 1px solid #ddd; padding: 5px 0 }
  .contentItems { max-height: 200px; overflow-y: auto; }
  .contentItems::-webkit-scrollbar {
    width: 8px;
    height: 100%;
    display: none;
  }
  .eventItem { display: flex; text-align: left; padding: 8px 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; font-size: 0.85rem; }
  .eventItem:hover { background-color: #f5f7fa; }
  .date { width: 110px; }
  .type { width: 160px; font-weight: 500; }
  .description { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .empty { color: #888; font-size: 0.85rem; padding: 15px 0; text-align: center; }
</style>
